<template>
  <div class="controls">
    <button v-if="gameStatus == -1" @click="controlGameStatus(0)">Start</button>&nbsp;
    <button v-if="gameStatus == 1" @click="controlGameStatus(0)">Resume</button>&nbsp;
    <button v-if="gameStatus == 0" @click="controlGameStatus(1)">Pause</button>&nbsp;
    <button v-if="gameStatus > -1" @click="controlGameStatus(-2)">Neustart</button>&nbsp;
    <button @click="addRevealedCards">mehr aufdecken</button>&nbsp;
    <button v-if="gameStatus > -1 && gameStatus <1" @click="checkAndMarkSets('all')">auf SETs prüfen</button>&nbsp;
    <button v-if="gameStatus > -1 && gameStatus <1" @click="checkAndMarkSets('first')">Hint</button>&nbsp;
    <span>SETs in current Deck:<span>{{ this.numOfDetectedSets ? this.numOfDetectedSets : " ?" }}</span></span>
    <button v-if="gameStatus > -1 && gameStatus <1" @click="toggleFoundSets">Toggle Found Sets</button>&nbsp;
  </div>
</template>

<script>
import config from "@/assets/config.json";

export default {
  name: 'ControlElements',
  props: ['addRevealedCards', 'checkAndMarkSets', 'numOfDetectedSets', 'gameStatus', 'controlGameStatus', 'toggleFoundSets'],

  data() {
    return {
      debugMode: config.debugMode
    }
  }
}
</script>

